<script setup>
  import {useHelpers} from "@/useHelpers"

  defineProps({
    subscriptions: {
      type: Array,
      required: true
    }
  })

  const selectedSubscription = defineModel()

  const handleSelectSubscription = (code) => {
    selectedSubscription.value = ''
    selectedSubscription.value = code
  }

  const { formatMoney } = useHelpers()
</script>
<template>
  <div
      v-if="subscriptions.length"
      class="pricing-page__limited"
  >
    <div class="pricing-page__section-header">
      <h3 class="pricing-page__limited-title">
        {{ $t('Limited Subscriptions Editions') }}
      </h3>
      <p class="pricing-page__limited-description basic-16">
        {{ $t('Limited Subscriptions Editions Text') }}
      </p>
    </div>

    <div class="pricing-page__limited-products">
      <template
          v-for="subscription in subscriptions"
          :key="`bundled-subscription-${subscription.id}`"
      >
        <div
            v-for="bundle in subscription.bundle"
            :key="`bundled-subscription-${subscription.id}-bundle-${bundle.id}`"
            class="pricing-page__limited-product"
        >
          <div class="pricing-page__limited-product-img-wrapper">
            <img
                v-if="bundle.img"
                class="pricing-page__limited-product-img"
                :src="bundle.img"
                :alt="bundle.name"
            />
            <svg
                v-else
                class="pricing-page__limited-product-img"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M49 7V49H7V7H49Z" stroke="#94A3B8" stroke-width="2" stroke-linecap="square"/>
              <path d="M8 37.1L23.5556 30.5L48 41.5" stroke="#94A3B8" stroke-width="2" stroke-linecap="square"/>
              <path d="M37.3333 23.3333C34.756 23.3333 32.6667 21.244 32.6667 18.6667C32.6667 16.0893 34.756 14 37.3333 14C39.9107 14 42 16.0893 42 18.6667C42 21.244 39.9107 23.3333 37.3333 23.3333Z" stroke="#94A3B8" stroke-width="2" stroke-linecap="square"/>
            </svg>
          </div>

          <div class="pricing-page__limited-product-info">
            <a
                href="#"
                @click.prevent="handleSelectSubscription(subscription.code)"
                class="pricing-page__limited-product-title"
            >
              <h6>
                {{ subscription.name }}
                <template v-if="bundle.name">
                  + {{ bundle.name }}
                </template>
              </h6>
              <h6>{{ formatMoney(subscription.price) }}</h6>
            </a>

            <p class="basic-14">{{ subscription.description }}</p>

            <a
                href="#"
                @click.prevent="handleSelectSubscription(subscription.code)"
            >
              <span class="link-underline-14">{{ $t('Order subscription' )}}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 6L14 8L12 10" stroke="#020617" stroke-width="1.5" stroke-linecap="square"></path>
                <path d="M3 8H13" stroke="#020617" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path>
              </svg>
            </a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
